<template>
  <div :id="componentId" class="spm1-agenda" :style="{ backgroundColor }">
    <div class="spm1-agenda-header">
      <span class="spm1-agenda-date">{{ dateText }}</span>
      <span class="spm1-agenda-week">{{ weekText }}</span>
    </div>
    <div class="spm1-agenda-body">
      <div
        v-for="(group, gIdx) in groups"
        :key="gIdx"
        class="spm1-agenda-group"
      >
        <div class="spm1-agenda-label-bar">
          <span
            class="spm1-agenda-label-dot"
            :class="[`is-${group.labelType}`]"
          />
          <span class="spm1-agenda-label-text">{{ group.label }}</span>
        </div>
        <div class="spm1-agenda-cards">
          <div
            v-for="(item, iIdx) in group.items"
            :key="iIdx"
            class="spm1-agenda-card"
            :style="{ backgroundImage: `url(${cardBackgroundImage})` }"
          >
            <span class="spm1-agenda-time">{{ item.time }}</span>
            <span class="spm1-agenda-title">{{ item.title }}</span>
            <div class="spm1-agenda-meta">
              <span v-if="item.speaker" class="spm1-agenda-speaker">{{ item.speaker }}</span>
              <span v-if="item.role" class="spm1-agenda-role">{{ item.role }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileAgendaSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_7'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(247, 248, 249, 1)',
      cardBackgroundImage: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNGc8f4d5f56f8d6959e077f3d570c65ddd.png'),
      dateText: '12/20',
      weekText: '星期四',
      items: [
        {
          label: '致 辞',
          isMain: true,
          time: '9:30-9:40',
          title: '开场致辞',
          speaker: '社领导',
          role: ''
        },
        {
          label: '',
          isMain: false,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        },
        {
          label: '主旨演讲',
          isMain: true,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        },
        {
          label: '品牌发布',
          isMain: false,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        },
        {
          label: '',
          isMain: false,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        },
        {
          label: '品牌推动',
          isMain: false,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        },
        {
          label: '合作签约',
          isMain: false,
          time: '9:40-10:20',
          title: '开场致辞',
          speaker: '张 超',
          role: '《中国品牌》杂志社社长'
        }
      ]
    }
  },
  computed: {
    groups() {
      const result = [];
      let currentGroup = null;
      this.items.forEach(item => {
        if (item.label) {
          currentGroup = {
            label: item.label,
            labelType: item.isMain ? 'solid' : 'hollow',
            items: [item]
          };
          result.push(currentGroup);
        } else if (currentGroup) {
          currentGroup.items.push(item);
        }
      });
      return result;
    }
  }
}
</script>

<style scoped>
.spm1-agenda {
  width: 100%;
  padding: 16px 12px;
  box-sizing: border-box;
}

.spm1-agenda-header {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 16px;
}

.spm1-agenda-date {
  font-size: 30px;
  line-height: 1;
  color: rgba(43, 131, 120, 1);
  font-weight: 700;
}

.spm1-agenda-week {
  font-size: 14px;
  color: rgba(43, 131, 120, 1);
  font-weight: 500;
}

.spm1-agenda-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.spm1-agenda-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.spm1-agenda-label-bar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  padding: 4px 10px 4px 6px;
  background-color: rgba(240, 242, 244, 1);
  border-radius: 0 12px 12px 0;
}

.spm1-agenda-label-dot {
  flex-shrink: 0;
  width: 6px;
  height: 14px;
  border-radius: 3px;
}

.spm1-agenda-label-dot.is-solid {
  background-color: rgba(43, 131, 120, 1);
}

.spm1-agenda-label-dot.is-hollow {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1.5px solid rgba(43, 131, 120, 0.6);
  background-color: transparent;
}

.spm1-agenda-label-text {
  font-size: 13px;
  color: rgba(43, 131, 120, 1);
  font-weight: 600;
  white-space: nowrap;
}

.spm1-agenda-cards {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.spm1-agenda-card {
  display: grid;
  grid-template-columns: 80px 1fr 190px;
  align-items: center;
  gap: 8px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border: 1.5px dashed rgba(43, 131, 120, 0.35);
  border-radius: 8px;
  padding: 8px 10px;
  min-height: 44px;
}

.spm1-agenda-time {
  width: 80px;
  font-size: 13px;
  color: rgba(43, 131, 120, 1);
  font-weight: 500;
  white-space: nowrap;
}

.spm1-agenda-title {
  font-size: 13px;
  color: rgba(43, 131, 120, 1);
  font-weight: 500;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.spm1-agenda-meta {
  display: grid;
  grid-template-columns: 50px 1fr;
  gap: 4px;
  align-items: center;
  width: 190px;
}

.spm1-agenda-speaker {
  width: 50px;
  font-size: 13px;
  color: rgba(43, 131, 120, 1);
  font-weight: 500;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.spm1-agenda-role {
  font-size: 11px;
  color: rgba(43, 131, 120, 0.8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
